import { render, staticRenderFns } from "./SerialNumberInput.vue?vue&type=template&id=6838af18&scoped=true&"
import script from "./SerialNumberInput.vue?vue&type=script&lang=js&"
export * from "./SerialNumberInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6838af18",
  null
  
)

export default component.exports